export default __webpack_public_path__ + "static/media/avatar6.c8e1a05c.png";